"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMetrics = exports.Metrics = void 0;
const enums_1 = require("../enums");
exports.Metrics = [
    {
        alias: 'news',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'New conversations',
    },
    {
        alias: 'answered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered conversations',
        description: 'Conversation with at least 1 reply or answer to a call.',
    },
    {
        alias: 'abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned conversations',
        description: 'Conversations resolved without at least 1 reply, or no answer to voice call',
        negative: true,
    },
    {
        alias: 'answered_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered + abandoned conversations',
    },
    {
        alias: 'offered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Offered conversations',
        description: 'Sum of answered & abandoned conversations. Unhandled conversations not included!',
    },
    {
        alias: 'resolved_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Closed/Resolved + Abandoned',
        description: 'Sum of resolved/closed & abandoned conversations.',
    },
    {
        alias: 'resolved_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Closed/Resolved + Answered',
        description: 'Sum of resolved/closed & answered conversations.',
    },
    {
        alias: 'resolved_abandoned_unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Closed/Resolved + Abandoned + Unhandled',
        description: 'Sum of resolved/closed, abandoned & unhandled conversations.',
    },
    {
        alias: 'resolved',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Closed / Resolved conversations',
        description: 'Total number of closed or resolved conversations',
    },
    {
        alias: 'answer_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answer rate (conversations)',
        description: 'Percent of answered conversations to total answered + abandoned conversations',
    },
    {
        alias: 'abandoned_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned rate (conversations)',
        description: 'Percent of abandoned conversations to total answered + abandoned conversations',
    },
    {
        alias: 'ongoing_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversation ongoing time',
        description: 'Total conversation ongoing time',
    },
    {
        alias: 'handling_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivityHandlingTime,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversation handling time',
        description: 'Total conversation handling time',
    },
    {
        alias: 'handling_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivityHandlingTime, enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average conversation handling time',
        description: 'Average handling time per resolved conversation',
    },
    {
        alias: 'sla_ongoing_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversation SLA ongoing time',
        description: 'Total conversation SLA ongoing time',
    },
    {
        alias: 'pre_queue_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversations pre queue time',
        description: 'Time spent in Journey before a Queue action is invoked or exited before joining a queue (unhandled).',
    },
    {
        alias: 'wait_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversation wait time',
        description: 'Total conversation wait time (abandoned + answered)',
    },
    {
        alias: 'sla_wait_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversation SLA wait time',
        description: 'Total conversation SLA wait time (abandoned + answered)',
    },
    {
        alias: 'pre_queue_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered conversations pre queue time',
        description: 'Time spent in Journey before a Queue action is invoked.',
    },
    {
        alias: 'wait_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered conversations wait time',
        description: 'Total wait time of answered conversations',
    },
    {
        alias: 'sla_wait_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered conversations SLA wait time',
        description: 'Total SLA wait time of answered conversations',
    },
    {
        alias: 'pre_queue_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned conversations pre queue time',
        description: 'Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'wait_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned conversations wait time',
        description: 'Total await time of abandoned conversations',
        negative: true,
    },
    {
        alias: 'sla_wait_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned conversations SLA wait time',
        description: 'Total SLA await time of abandoned conversations',
        negative: true,
    },
    {
        alias: 'pre_queue_time_unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Unhandled conversations pre queue time',
        description: 'Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'points',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        custom_percent: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Conversation points',
        description: 'Points earned creating, resolving or closing conversations',
    },
    {
        alias: 'total_points',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        custom_percent: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total points',
        description: 'Total of conversation + message points',
    },
    {
        alias: 'total_points_per_effective_work_time_hour',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        of_total: true,
        custom_percent: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total points per hour',
        description: 'Total points per effective work time hour',
    },
    {
        alias: 'resolved_per_effective_work_time_hour',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        of_total: true,
        custom_percent: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Closed / Resolved conversations per effective hour',
        description: 'Total number of closed or resolved conversations per effective work time hour',
    },
    {
        alias: 'resolved_abandoned_per_effective_work_time_hour',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        of_total: true,
        custom_percent: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Closed/Resolved + Abandoned conversations per effective hour',
        description: 'Sum of resolved/closed & abandoned conversations per effective work time hour',
    },
    {
        alias: 'wait_time_max',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Highest conversation wait time',
        description: 'Highest wait time of answered conversations',
        negative: true,
    },
    {
        alias: 'wait_time_min',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Least conversation wait time',
        description: 'Least wait time of answered conversations',
        negative: true,
    },
    {
        alias: 'ongoing_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average conversation ongoing time',
        description: 'Average ongoing time of answered and resolved conversations. (None answered / abandoned conversations not included)',
        negative: true,
    },
    {
        alias: 'sla_ongoing_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average conversation SLA ongoing time',
        description: 'Average SLA ongoing time of answered and resolved conversations. (None answered / abandoned conversations not included)',
        negative: true,
    },
    {
        alias: 'pre_queue_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average conversation pre queue time',
        description: 'Average pre queue time of answered or none answered, abandoned & unhandled conversations. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'wait_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average conversation wait time',
        description: 'Average wait time of answered or none answered / abandoned conversations.',
        negative: true,
    },
    {
        alias: 'sla_wait_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average conversation SLA wait time',
        description: 'Average SLA wait time of answered or none answered / abandoned conversations.',
        negative: true,
    },
    {
        alias: 'pre_queue_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average none answered / abandoned conversations pre queue time',
        description: 'Average none answered / abandoned conversations pre queue time. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'wait_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average none answered / abandoned conversations wait time',
        negative: true,
    },
    {
        alias: 'sla_wait_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average none answered / abandoned conversations SLA wait time',
        negative: true,
    },
    {
        alias: 'pre_queue_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average answered conversation pre queue time',
        description: 'Average pre queue time of answered conversations. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'pre_queue_time_unhandled_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average unhandled conversation pre queue time',
        description: 'Average pre queue time of unhandled conversations. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'wait_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average answered conversations wait time',
        negative: true,
    },
    {
        alias: 'sla_wait_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Average answered conversations SLA wait time',
        negative: true,
    },
    {
        alias: 'unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Unhandled conversations',
        description: 'Conversations closed without a queue assigned to it.',
    },
    {
        alias: 'sla_resolved_met',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA met',
        description: 'Number of conversations resolved within defined resolve SLA policy.',
    },
    {
        alias: 'sla_resolved_met_of_all_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA met percent of all conversations',
        description: 'Percent of conversations resolved within defined resolve SLA policy, compared to all conversations.',
    },
    {
        alias: 'sla_resolved_met_of_sla_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA met percent of conversations that met or failed resolve SLA policy',
        description: 'Percent of conversations resolved within defined resolve SLA policy, compared to all conversations that met or failed resolve SLA policy.',
    },
    {
        alias: 'sla_resolved_fail',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA exceeded',
        description: 'Number of conversations failed to be resolved within defined resolve SLA policy.',
        negative: true,
    },
    {
        alias: 'sla_resolved_fail_of_all_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA exceeded percent of all conversations',
        description: 'Percent of conversations failed to be resolved within defined resolve SLA policy, compared to all conversations.',
        negative: true,
    },
    {
        alias: 'sla_resolved_fail_of_sla_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA exceeded percent of conversations that met or failed resolve SLA policy',
        description: 'Percent of conversations failed to be resolved within defined resolve SLA policy, compared to all conversations that met or failed resolve SLA policy.',
        negative: true,
    },
    {
        alias: 'sla_first_response_met',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA met',
        description: 'Number of conversations responded within defined SLA first response policy.',
    },
    {
        alias: 'sla_first_response_met_of_all_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA met percent of all conversations',
        description: 'Percent of conversations responded within defined SLA first response policy, compared to all conversations.',
    },
    {
        alias: 'sla_first_response_met_of_sla_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA met percent of conversations that met or failed first response SLA policy',
        description: 'Percent of conversations responded within defined SLA first response policy, compared to all conversations that met or failed first response SLA policy.',
    },
    {
        alias: 'sla_first_response_fail',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA exceeded',
        description: 'Number of conversations failed to respond within defined SLA first response policy.',
        negative: true,
    },
    {
        alias: 'sla_first_response_fail_of_all_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA exceeded percent of all conversations',
        description: 'Percent of conversations failed to respond within defined SLA first response policy, compared to all conversations.',
        negative: true,
    },
    {
        alias: 'sla_first_response_fail_of_sla_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA exceeded percent of conversations that met or failed first response SLA policy',
        description: 'Percent of conversations failed to respond within defined SLA first response policy, compared to all conversations that met or failed first response SLA policy.',
        negative: true,
    },
    {
        alias: 'sla_every_response_met',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA messages / voice call bridges met',
        description: 'Number of messages / voice call bridges responded within defined every response SLA policy.',
    },
    {
        alias: 'sla_every_response_fail',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA messages / voice call bridges exceeded',
        description: 'Number of messages / voice call bridges failed to be responded within defined every response SLA policy.',
        negative: true,
    },
    {
        alias: 'message_points',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        custom_percent: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Message points',
        description: 'Points earned on messages',
    },
    {
        alias: 'sla_every_response_met_of_all_messages',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA met percent of all messages / voice call bridges',
        description: 'Percent of messages / voice call bridges responded within defined every response SLA policy, compared to all messages / voice call bridges.',
    },
    {
        alias: 'sla_every_response_fail_of_all_messages',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA exceeded percent of all messages / voice call bridges',
        description: 'Percent of messages / voice call bridges failed to be responded within defined every response SLA policy, compared to all messages / voice call bridges.',
        after_seconds: true,
        negative: true,
    },
    {
        alias: 'sla_every_response_met_of_sla_messages',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA met percent of messages / voice call bridges with every response SLA policy',
        description: 'Percent of messages / voice call bridges responded within defined every response SLA policy, compared to all messages / voice call bridges with every response SLA policy.',
    },
    {
        alias: 'sla_every_response_fail_of_sla_messages',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA exceeded percent of messages / voice call bridges with every response SLA policy',
        description: 'Percent of messages / voice call bridges failed to be responded within defined every response SLA policy, compared to all messages / voice call bridges with every response SLA policy.',
        negative: true,
    },
    {
        alias: 'sla_first_response_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'First response SLA conversations',
        description: 'Total number of conversation that met or failed first response SLA policy.',
    },
    {
        alias: 'sla_every_response_messages',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.MailMessage,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice, enums_1.ChannelEnum.Mail,],
        title: 'Every response SLA messages / voice call bridges',
        description: 'Total number of messages / voice call bridges that met or failed every response SLA policy.',
    },
    {
        alias: 'sla_resolve_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolve SLA conversations',
        description: 'Total number of conversations that met or failed resolve SLA policy.',
    },
    {
        alias: 'sla_resolved_uncertain',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Uncertain resolve SLA conversations',
        description: 'Total number of queue assigned and none-resolved conversations with resolve SLA policy that has not expired.',
    },
    {
        alias: 'sla_ongoing_resolved_fail',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Exceeded resolve SLA ongoing conversations',
        description: 'Total number of queue assigned and none-resolved ongoing conversations with resolve SLA policy that has exceeded.',
    },
    {
        alias: 'sla_first_response_uncertain',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Uncertain first response SLA conversations',
        description: 'Total number of queue assigned and none-answered conversations with first response SLA policy that has not expired.',
    },
    {
        alias: 'sla_waiting_first_response_fail',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Exceeded first response SLA waiting conversations',
        description: 'Total number of queue assigned and none-resolved waiting conversations with first response SLA policy that has exceeded.',
    },
    {
        alias: 'answered_within',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered conversations within',
        description: 'Answered conversations within selected time threshold.',
        within_seconds: true,
    },
    {
        alias: 'answered_within_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Percent of answered conversations within',
        description: 'Percent of answered conversations within selected time threshold compared to total answered conversations.',
        within_seconds: true,
    },
    {
        alias: 'answered_after',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Answered conversations after',
        description: 'Answered conversations after selected time threshold.',
        after_seconds: true,
    },
    {
        alias: 'answered_after_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Percent of answered conversations after',
        description: 'Percent of answered conversations after selected time threshold compared to total answered conversations.',
        after_seconds: true,
    },
    {
        alias: 'abandoned_within',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned conversations within',
        description: 'Abandoned conversation within selected time threshold.',
        within_seconds: true,
    },
    {
        alias: 'abandoned_within_of_total_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Percent of abandoned conversations within',
        description: 'Percent of abandoned conversation within selected time threshold compared to total abandoned conversations.',
        within_seconds: true,
    },
    {
        alias: 'abandoned_after',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Abandoned conversations after',
        description: 'Abandoned conversations after selected time threshold.',
        after_seconds: true,
    },
    {
        alias: 'abandoned_after_of_total_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Percent of abandoned conversations after',
        description: 'Percent of abandoned conversations after selected time threshold compared to total abandoned conversations.',
        after_seconds: true,
    },
    {
        alias: 'thread_news',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'New threads / voice calls',
        description: 'Total number of new calls / message threads.',
    },
    {
        alias: 'thread_answered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Answered voice calls',
        description: 'Number of answered calls, with ongoing calls included.',
        popular: true,
    },
    {
        alias: 'thread_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Answered voice calls / threads',
        description: 'Number of answered voice calls / message threads.',
        popular: true,
    },
    {
        alias: 'thread_answered_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Answered + abandoned threads / voice calls',
    },
    {
        alias: 'thread_offered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Offered threads / voice calls',
        description: 'Sum of answered & abandoned threads / voice calls. Unhandled threads / voice calls excluded!',
    },
    {
        alias: 'thread_offered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Offered voice calls',
        description: 'Sum of answered & abandoned voice calls. Unhandled voice calls excluded!',
    },
    {
        alias: 'thread_abandoned_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Abandoned voice calls',
        negative: true,
    },
    {
        alias: 'thread_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Abandoned voice calls / message threads',
        negative: true,
    },
    {
        alias: 'thread_answer_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Answer rate (threads / voice calls)',
        description: 'Percent of answered threads / voice calls compared to total answered + abandoned threads / voice calls',
    },
    {
        alias: 'thread_answer_rate_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Answer rate (voice calls)',
        description: 'Percent of answered voice calls compared to total answered + abandoned voice calls',
    },
    {
        alias: 'thread_abandoned_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Abandoned rate (threads / voice calls)',
        description: 'Percent of none answered threads / abandoned voice calls compared to total answered + abandoned threads / voice calls',
    },
    {
        alias: 'thread_abandoned_rate_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Abandoned rate (voice calls)',
        description: 'Percent of abandoned voice calls compared to total answered + abandoned voice calls',
    },
    {
        alias: 'thread_unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Unhandled threads / voice calls',
        description: 'Threads closed without a queue assigned to it + voice calls terminated without entering any queues. Most probable calls coming in outside business hours, or caller hangs up before selecting an voice menu option.',
    },
    {
        alias: 'thread_unhandled_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        thread_directions: [enums_1.DirectionEnum.InBound,],
        message_directions: [],
        title: 'Unhandled voice calls',
        description: 'Voice calls terminated without entering any queue. Most probable calls coming in outside business hours, or caller hangs up before selecting an voice menu option.',
    },
    {
        alias: 'thread_per_conversation',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average threads / voice calls per conversation',
        description: 'Average number of threads / voice calls per conversation.',
    },
    {
        alias: 'thread_pre_queue_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of answered threads / voice calls',
        description: 'Total pre queue time of answered threads / voice calls. Time spent in Journey before a Queue action is invoked.',
    },
    {
        alias: 'thread_wait_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Wait time of answered threads / voice calls',
        description: 'Total wait time of answered threads / voice calls',
    },
    {
        alias: 'thread_pre_queue_time_answered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of answered voice calls',
        description: 'Total pre queue time of answered voice calls. Time spent in Journey before a Queue action is invoked.',
    },
    {
        alias: 'thread_wait_time_answered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Wait time of answered voice calls',
        description: 'Total wait time of answered voice calls',
    },
    {
        alias: 'thread_pre_queue_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of abandoned threads / voice calls',
        description: 'Total pre queue time of abandoned threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_abandoned_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of abandoned voice calls',
        description: 'Total pre queue time of abandoned voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_wait_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Wait time of abandoned threads / voice calls',
        description: 'Total wait time of abandoned threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time_abandoned_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Wait time of abandoned voice calls',
        description: 'Total wait time of abandoned voice calls',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of abandoned unhandled / voice calls',
        description: 'Total pre queue time of unhandled threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_unhandled_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of unhandled voice calls',
        description: 'Total pre queue time of unhandled voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_ongoing_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Ongoing time of threads / voice calls',
        description: 'Total ongoing time of threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_ongoing_time_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Talk time (voice calls)',
        description: 'Total talk time voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Wait time of all threads / voice calls',
        description: 'Total wait time of all threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Wait time of all voice calls',
        description: 'Total wait time of all voice calls',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of all threads / voice calls',
        description: 'Total pre queue time of all threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Pre queue time of all voice calls',
        description: 'Total pre queue time of all voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average pre queue time of all threads / voice calls.',
        description: 'Average pre queue time of answered, abandoned & unhandled threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_wait_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average wait time of threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Average wait time of voice calls',
        negative: true,
    },
    {
        alias: 'thread_ongoing_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average ongoing time of threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_ongoing_time_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Average talk time (voice calls)',
        negative: true,
    },
    {
        alias: 'thread_ongoing_time_voice_avg_acw_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.UserActivityACW,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Average talk time (voice calls) + Average ACW',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average pre queue time of abandoned threads / voice calls.',
        description: 'Average pre queue time of none answered / abandoned threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_wait_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average wait time of abandoned threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time_abandoned_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Average wait time of abandoned voice calls',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average pre queue time of answered threads / voice calls.',
        description: 'Average pre queue time of answered threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_time_unhandled_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average pre queue time of unhandled threads / voice calls.',
        description: 'Average pre queue time of unhandled threads / voice calls. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'thread_wait_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Average wait time of answered threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time_answered_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Average wait time of answered voice calls',
        negative: true,
    },
    {
        alias: 'thread_wait_time_max',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Highest wait time of thread / voice call',
        negative: true,
    },
    {
        alias: 'thread_wait_time_max_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Highest wait time of voice call',
        negative: true,
    },
    {
        alias: 'thread_wait_time_min',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Least wait time of thread / voice call',
        negative: true,
    },
    {
        alias: 'thread_wait_time_min_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Least wait time of voice call',
    },
    {
        alias: 'thread_ongoing_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Maximum ongoing voice calls',
        description: 'Maximum number of ongoing voice calls at the same time',
        negative: true,
    },
    {
        alias: 'thread_waiting_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        title: 'Maximum waiting voice calls',
        description: 'Maximum number of waiting voice calls at the same time',
        negative: true,
    },
    {
        alias: 'thread_answered_within',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Answered threads / voice calls within',
        description: 'Answered threads / voice calls within selected time threshold.',
        within_seconds: true,
    },
    {
        alias: 'thread_answered_within_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Percent of answered threads / voice calls within',
        description: 'Percent of answered threads / voice calls within selected time threshold of total answered.',
        within_seconds: true,
    },
    {
        alias: 'thread_answered_after',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Answered threads / voice calls after',
        description: 'Answered threads / voice calls after selected time threshold.',
        after_seconds: true,
    },
    {
        alias: 'thread_answered_after_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Percent of answered threads / voice calls after',
        description: 'Percent of answered threads / voice calls after selected time threshold of total answered.',
        after_seconds: true,
    },
    {
        alias: 'thread_abandoned_within',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Abandoned threads / voice calls within',
        description: 'Abandoned threads / voice calls within selected time threshold.',
        within_seconds: true,
    },
    {
        alias: 'thread_abandoned_within_of_total_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Percent of abandoned threads / voice calls within',
        description: 'Percent of abandoned threads / voice calls within selected time threshold of total abandoned.',
        within_seconds: true,
    },
    {
        alias: 'thread_resolved',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Resolved threads / ended voice calls',
        description: 'Total number of closed / resolved threads, or ended voice calls',
    },
    {
        alias: 'thread_abandoned_after',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Abandoned threads / voice calls after',
        description: 'Abandoned threads / voice calls after selected time threshold.',
        after_seconds: true,
    },
    {
        alias: 'thread_abandoned_after_of_total_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        title: 'Percent of abandoned threads / voice calls after',
        description: 'Percent of abandoned threads / voice calls after selected time threshold of total abandoned.',
        after_seconds: true,
    },
    {
        alias: 'message_news',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'New messages / voice call bridges',
        description: 'Total number of new call bridges or messages (mail message, form submission, internal note).',
    },
    {
        alias: 'message_news_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'New voice call bridges',
        description: 'Total number of new voice call bridges.',
    },
    {
        alias: 'message_answered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Answered voice call bridges',
        description: 'Number of answered call bridges, with ongoing bridges included.',
        popular: true,
    },
    {
        alias: 'message_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Answered voice call bridges / messages',
        description: 'Number of answered voice call bridges, and answered messages (mail message, form submission).',
        popular: true,
    },
    {
        alias: 'message_answered_per_effective_work_time_hour',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        of_total: true,
        custom_percent: true,
        title: 'Answered voice call bridges / messages per effective hour',
        description: 'Number of answered voice call bridges, and answered messages (mail message, form submission) per effective work time hour',
    },
    {
        alias: 'message_abandoned_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Abandoned voice call bridges',
        negative: true,
    },
    {
        alias: 'message_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Abandoned voice call bridges / messages',
        negative: true,
    },
    {
        alias: 'message_answered_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Answered + abandoned messages / voice call bridges',
    },
    {
        alias: 'message_offered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Offered messages / voice call bridges',
        description: 'Total number of new messages / voice call bridges, unmanaged and timeout voice call bridges. Unhandled messages / voice call bridges excluded!',
    },
    {
        alias: 'message_offered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Offered voice call bridges',
        description: 'Total number of voice call bridges, unmanaged and timeout voice call bridges. Unhandled voice call bridges excluded!',
    },
    {
        alias: 'message_answer_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Answer rate (messages / voice call bridges)',
        description: 'Percent of answered messages / voice call bridges, compared to total offered messages / voice call bridges',
    },
    {
        alias: 'message_answer_rate_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Answer rate (Voice call bridges)',
        description: 'Percent of answered voice call bridges, compared to total offered voice call bridges',
    },
    {
        alias: 'message_abandoned_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Abandoned rate (messages / voice call bridges)',
        description: 'Percent of none answered messages / abandoned voice call bridges, compared to total offered messages / voice call bridges',
    },
    {
        alias: 'message_abandoned_rate_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Abandoned rate (Voice call bridges)',
        description: 'Percent of abandoned voice call bridges, compared to total offered voice call bridges',
    },
    {
        alias: 'message_unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Unhandled messages',
        description: 'None answered messages in threads closed without a queue assigned to it.',
    },
    {
        alias: 'message_per_conversation',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Average messages / voice call bridges per conversation',
        description: 'Average number of messages / voice call bridges per conversation.',
    },
    {
        alias: 'message_per_thread',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Average messages / voice call bridges per thread',
        description: 'Average number of messages / thread, voice call bridges per voice call.',
    },
    {
        alias: 'message_per_thread_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average voice call bridges per voice call',
        description: 'Average number of voice call bridges per voice call.',
    },
    {
        alias: 'message_answered_within',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Answered messages / voice call bridges within',
        description: 'Answered messages / voice call bridges within selected time threshold.',
        within_seconds: true,
    },
    {
        alias: 'message_answered_within_of_total_answered_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Percent of answered messages / voice call bridges within',
        description: 'Percent of answered messages / voice call bridges within selected time threshold of total answered.',
        within_seconds: true,
    },
    {
        alias: 'message_answered_after',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Answered messages / voice call bridges after',
        description: 'Answered messages / voice call bridges after selected time threshold.',
        after_seconds: true,
    },
    {
        alias: 'message_answered_after_of_total_answered_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Percent of answered messages / voice call bridges after',
        description: 'Percent of answered messages / voice call bridges after selected time threshold of total answered.',
        after_seconds: true,
    },
    {
        alias: 'message_abandoned_within',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Abandoned messages / voice call bridges within',
        description: 'Abandoned messages / voice call bridges within selected time threshold.',
        within_seconds: true,
    },
    {
        alias: 'message_abandoned_within_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Percent of abandoned messages / voice call bridges within',
        description: 'Percent of abandoned messages / voice call bridges within selected time threshold of total answered.',
        within_seconds: true,
    },
    {
        alias: 'message_resolved',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Resolved messages / ended voice call bridges',
        description: 'Total number of closed / resolved messages, or ended voice call bridges',
    },
    {
        alias: 'message_abandoned_after',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Abandoned messages / voice call bridges after',
        description: 'Abandoned messages / voice call bridges after selected time threshold.',
        after_seconds: true,
    },
    {
        alias: 'message_abandoned_after_of_total_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Percent of abandoned messages / voice call bridges after',
        description: 'Percent of abandoned messages / voice call bridges after selected time threshold of total answered.',
        after_seconds: true,
    },
    {
        alias: 'message_pre_queue_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Pre queue time of answered messages / voice call bridges',
        description: 'Total pre queue time of answered messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
    },
    {
        alias: 'message_pre_queue_time_answered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Pre queue time of answered voice call bridges',
        description: 'Total pre queue time of answered voice call bridges. Time spent in Journey before a Queue action is invoked.',
    },
    {
        alias: 'message_wait_time_answered',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Wait time of answered messages / voice call bridges',
        description: 'Total wait time of answered messages / voice call bridges',
    },
    {
        alias: 'message_wait_time_answered_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Wait time of answered voice call bridges',
        description: 'Total wait time of answered voice call bridges',
    },
    {
        alias: 'message_pre_queue_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Pre queue time of abandoned messages / voice call bridges',
        description: 'Total pre queue time of abandoned messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_abandoned_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Pre queue time of abandoned voice call bridges',
        description: 'Total pre queue time of abandoned voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_wait_time_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Wait time of abandoned messages / voice call bridges',
        description: 'Total wait time of abandoned messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_wait_time_abandoned_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Wait time of abandoned voice call bridges',
        description: 'Total wait time of abandoned voice call bridges',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_unhandled',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Pre queue time of unhandled messages / voice call bridges',
        description: 'Total pre queue time of unhandled messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_unhandled_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Pre queue time of unhandled voice call bridges',
        description: 'Total pre queue time of unhandled voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_ongoing_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Ongoing time of messages / voice call bridges',
        description: 'Total ongoing time of messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_ongoing_time_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Talk time (voice call bridges)',
        description: 'Total talk time voice call bridges',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Pre queue time of all messages / voice call bridges',
        description: 'Total pre queue time of all messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Pre queue time of all voice call bridges',
        description: 'Total pre queue time of all voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_wait_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        title: 'Wait time of all messages / voice call bridges',
        description: 'Total wait time of all messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_wait_time_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Wait time of all voice call bridges',
        description: 'Total wait time of all voice call bridges',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average pre queue time of all messages / voice call bridges.',
        description: 'Average pre queue time of answered, abandoned & unhandled messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_wait_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average wait time of messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_wait_time_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average wait time of voice call bridges',
        negative: true,
    },
    {
        alias: 'message_ongoing_time_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average ongoing time of messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_ongoing_time_voice_avg_acw_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.UserActivityACW,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average talk time (voice call bridges) + Average ACW',
        negative: true,
    },
    {
        alias: 'message_ongoing_time_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average talk time (voice call bridges)',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average pre queue time of abandoned messages / voice call bridges.',
        description: 'Average pre queue time of none answered / abandoned messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_wait_time_abandoned_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average wait time of abandoned messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_wait_time_abandoned_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average wait time of abandoned voice call bridges',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_unhandled_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average pre queue time of unhandled messages / voice call bridges.',
        description: 'Average pre queue time of unhandled messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_pre_queue_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average pre queue time of answered messages / voice call bridges.',
        description: 'Average pre queue time of answered messages / voice call bridges. Time spent in Journey before a Queue action is invoked.',
        negative: true,
    },
    {
        alias: 'message_wait_time_answered_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Average wait time of answered messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_wait_time_answered_voice_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average wait time of answered voice call bridges',
        negative: true,
    },
    {
        alias: 'message_wait_time_max',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Highest wait time of message / voice call bridge',
        negative: true,
    },
    {
        alias: 'message_wait_time_max_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Highest wait time of voice call bridge',
        negative: true,
    },
    {
        alias: 'message_wait_time_min',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        title: 'Least wait time of message / voice call bridge',
        negative: true,
    },
    {
        alias: 'message_wait_time_min_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Least wait time of voice call bridge',
    },
    {
        alias: 'message_ongoing_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Maximum ongoing voice call bridges',
        description: 'Maximum number of ongoing voice call bridges at the same time',
        negative: true,
    },
    {
        alias: 'message_waiting_voice',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Maximum waiting voice call bridges',
        description: 'Maximum number of waiting voice call bridges at the same time',
        negative: true,
    },
    {
        alias: 'transfer_in',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        title: 'Threads / voice call bridges transferred in',
    },
    {
        alias: 'transfer_out',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        title: 'Threads / voice call bridges transferred out',
    },
    {
        alias: 'unmanaged',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        title: 'Unmanaged threads / voice call bridges',
        description: 'Unmanaged threads / The total number of unmanaged queue Calls, for all the existing Queues. It includes the calls which are abandoned for reasons joinempty, leavewhenempty and exitwithkey. Timeout has its own metric.',
    },
    {
        alias: 'timeout',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        title: 'Timeout threads / voice call bridges',
        description: 'Timed out threads / Voice call bridge hanged up by system due to no answer within defined timeout in queue settings.',
    },
    {
        alias: 'ping_total',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Total pings',
        description: 'Total number of pings (accepted + none answered for any reason)',
    },
    {
        alias: 'ping_fail_total',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Total no answer pings',
        description: 'No answer reasons: rejected, abandoned, timeout.',
        negative: true,
    },
    {
        alias: 'pinged_conversations',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Pinged conversations',
        description: 'Number of conversation having at least 1 ping.',
    },
    {
        alias: 'ping_per_conversation',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Average ping per conversation',
        description: 'Average number of pings per pinged conversation',
    },
    {
        alias: 'ping_fail_per_conversation',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Average no answer ping per conversation',
        description: 'Average number of none answered pings per pinged conversation. No answer reasons: rejected, abandoned, timeout.',
        negative: true,
    },
    {
        alias: 'ping_accept_per_conversation',
        unit_type: enums_1.MetricUnitTypeEnum.Decimal,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Average accepted pings per conversation',
        description: 'Average number of accepted pings per pinged conversation',
        negative: true,
    },
    {
        alias: 'ping_accepted',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Ping accepted',
        description: 'Number of accepted pings',
    },
    {
        alias: 'ping_rejected',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Ping rejected',
        description: 'Number of none answered pings. No answer reasons: rejected, abandoned, timeout.',
        negative: true,
    },
    {
        alias: 'ping_timeout',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Ping timeout',
        description: 'Ping terminated by system due to no answer within defined timeout in queue settings.',
    },
    {
        alias: 'ping_abandoned',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Ping abandoned',
        description: 'Ping terminated by system as caller hanged up during ping lifetime.',
        negative: true,
    },
    {
        alias: 'ping_accept_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Ping accept rate',
    },
    {
        alias: 'ping_fail_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        message_directions: [enums_1.DirectionEnum.InBound, enums_1.DirectionEnum.Internal,],
        title: 'Ping no answer rate',
        description: 'No answer reasons: rejected, abandoned, timeout.',
        negative: true,
    },
    {
        alias: 'agent_offered',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote, enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        of_total: true,
        title: 'Agent offered',
        description: 'Total number of answered messages / voice call bridges by agent + none answered pings: rejected, abandoned, timeout.',
    },
    {
        alias: 'agent_answer_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Agent answer rate',
        description: 'Percent of answered messages / voice call bridges by agent compared to agent offered.',
    },
    {
        alias: 'agent_abandoned_rate',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission, enums_1.MetricDataSourceEnum.InternalNote,],
        default: 0,
        of_total: true,
        title: 'Agent abandoned rate',
        description: 'Percent of abandoned messages / voice call bridges by agent compared to agent offered.',
    },
    {
        alias: 'pre_queue_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Pre-Queue conversations',
        description: 'Total number of currently pre-queue conversations',
        negative: true,
    },
    {
        alias: 'ongoing_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Ongoing conversations',
        description: 'Total number of currently ongoing conversations',
        negative: true,
    },
    {
        alias: 'waiting_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Waiting conversations',
        description: 'Total number of currently waiting conversations',
        negative: true,
    },
    {
        alias: 'waiting_ongoing_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Waiting + Ongoing conversations',
        description: 'Sum of currently waiting & ongoing conversations',
        negative: true,
    },
    {
        alias: 'oldest_waiting_live',
        unit_type: enums_1.MetricUnitTypeEnum.Countdown,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: null,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        format: enums_1.StatsWidgetMetricFormatEnum.COUNTDOWN,
        title: 'Longest waiting conversation',
        negative: true,
    },
    {
        alias: 'thread_pre_queue_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        live: true,
        title: 'Pre-Queue threads / voice calls',
        description: 'Total number of currently pre-queue threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_ongoing_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        live: true,
        title: 'Ongoing threads / voice calls',
        description: 'Total number of currently ongoing threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_ongoing_voice_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        live: true,
        title: 'Ongoing voice calls',
        description: 'Total number of currently ongoing voice calls',
        negative: true,
    },
    {
        alias: 'thread_waiting_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        message_channels: [],
        message_directions: [],
        live: true,
        title: 'Waiting threads / voice calls',
        description: 'Total number of currently waiting threads / voice calls',
        negative: true,
    },
    {
        alias: 'thread_waiting_voice_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        live: true,
        title: 'Waiting voice calls',
        description: 'Total number of currently waiting voice calls',
        negative: true,
    },
    {
        alias: 'thread_oldest_waiting_live',
        unit_type: enums_1.MetricUnitTypeEnum.Countdown,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        message_channels: [],
        message_directions: [],
        live: true,
        format: enums_1.StatsWidgetMetricFormatEnum.COUNTDOWN,
        title: 'Longest waiting thread / voice call',
        negative: true,
    },
    {
        alias: 'thread_oldest_waiting_voice_live',
        unit_type: enums_1.MetricUnitTypeEnum.Countdown,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [],
        message_directions: [],
        live: true,
        format: enums_1.StatsWidgetMetricFormatEnum.COUNTDOWN,
        title: 'Longest waiting voice call',
        negative: true,
    },
    {
        alias: 'message_pre_queue_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        live: true,
        title: 'Pre-Queue messages / voice call bridges',
        description: 'Total number of currently pre-queue messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_ongoing_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        live: true,
        title: 'Ongoing messages / voice call bridges',
        description: 'Total number of currently ongoing messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_ongoing_voice_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        live: true,
        title: 'Ongoing voice call bridges',
        description: 'Total number of currently ongoing voice call bridges',
        negative: true,
    },
    {
        alias: 'message_waiting_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: 0,
        of_total: true,
        live: true,
        title: 'Waiting messages / voice call bridges',
        description: 'Total number of currently waiting messages / voice call bridges',
        negative: true,
    },
    {
        alias: 'message_waiting_voice_live',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: 0,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        live: true,
        title: 'Waiting voice call bridges',
        description: 'Total number of currently waiting voice call bridges',
        negative: true,
    },
    {
        alias: 'message_oldest_waiting_live',
        unit_type: enums_1.MetricUnitTypeEnum.Countdown,
        sources: [enums_1.MetricDataSourceEnum.MailMessage, enums_1.MetricDataSourceEnum.VoiceCall, enums_1.MetricDataSourceEnum.FormSubmission,],
        default: null,
        of_total: true,
        live: true,
        format: enums_1.StatsWidgetMetricFormatEnum.COUNTDOWN,
        title: 'Longest waiting message / voice call bridge',
        negative: true,
    },
    {
        alias: 'message_oldest_waiting_voice_live',
        unit_type: enums_1.MetricUnitTypeEnum.Countdown,
        sources: [enums_1.MetricDataSourceEnum.VoiceCall,],
        default: null,
        of_total: true,
        message_channels: [enums_1.ChannelEnum.Voice,],
        live: true,
        format: enums_1.StatsWidgetMetricFormatEnum.COUNTDOWN,
        title: 'Longest waiting voice call bridge',
        negative: true,
    },
    {
        alias: 'signed_in',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Signed in',
        description: 'Number of signed in users during selected/grouped period/interval.',
    },
    {
        alias: 'login_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Login time',
        description: 'Login time as highest status. Status order: login, idle, working (partial busy or handling), pause, busy.',
    },
    {
        alias: 'effective_work_time_login_time',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Effective work time / Login time',
        description: 'Percent of effective work time of total login time',
    },
    {
        alias: 'pause_time_login_time',
        unit_type: enums_1.MetricUnitTypeEnum.Percent,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        of_total: true,
        thread_channels: [],
        message_channels: [],
        thread_directions: [],
        message_directions: [],
        title: 'Pause time / Login time',
        description: 'Percent of pause time of total login time',
    },
    {
        alias: 'total_login_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total logged in time',
    },
    {
        alias: 'pause_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Pause time',
        description: 'Pause time as highest status. Status order: login, idle, working (partial busy or handling), pause, busy.',
    },
    {
        alias: 'pause_work_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total pause time (work time)',
        description: 'Total pause time where pause is flagged as work time, including ACW.',
    },
    {
        alias: 'pause_none_work_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total pause time (none working)',
        description: 'Total pause time where pause is not flagged as work time.',
    },
    {
        alias: 'idle_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Idle time',
        description: 'Idle time as highest status. Status order: login, idle, working (partial busy or handling), pause, busy.',
    },
    {
        alias: 'total_idle_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total idle time',
    },
    {
        alias: 'work_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total handling + partial busy time',
        description: 'Total handling + partial busy time as highest status',
    },
    {
        alias: 'total_work_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total work time',
        description: 'Total logged in time excluding pause time where pause is not marked as work time.',
    },
    {
        alias: 'total_effective_work_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total effective work time',
        description: 'Effective work time: work time + busy. Paused time, without effective work time flag on, excluded.',
    },
    {
        alias: 'total_efficient_work_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total efficient work time',
        description: 'Efficient work time: work time + busy time + pauses marked as work time.',
    },
    {
        alias: 'invoiceable_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Invoiceable time',
        description: 'Invoiceable time: total login time, excluding pauses not marked as invoiceable.',
    },
    {
        alias: 'none_invoiceable_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Total none invoiceable time',
        description: 'Total pause time where pause has not been marked as invoiceable.',
    },
    {
        alias: 'busy_time',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Busy time',
    },
    {
        alias: 'acw',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivityACW,],
        default: 0,
        of_total: true,
        channels: [enums_1.ChannelEnum.Voice,],
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'ACW',
        description: 'Total after call work time.',
    },
    {
        alias: 'acw_avg',
        unit_type: enums_1.MetricUnitTypeEnum.Second,
        sources: [enums_1.MetricDataSourceEnum.UserActivityACW,],
        default: 0,
        of_total: true,
        channels: [enums_1.ChannelEnum.Voice,],
        thread_channels: [enums_1.ChannelEnum.Voice,],
        message_channels: [enums_1.ChannelEnum.Voice,],
        title: 'Average ACW',
        description: 'Average after call work time per answered voice call',
    },
    {
        alias: 'status',
        unit_type: enums_1.MetricUnitTypeEnum.Status,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Status',
        description: 'Current agent status.',
        agent: true,
        client_data: true,
    },
    {
        alias: 'status_info',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Status info',
        description: 'Current agent status info.',
        agent: true,
        client_data: true,
    },
    {
        alias: 'status_agentprofile',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Agent profile',
        description: 'Current agent profile.',
        agent: true,
        client_data: true,
    },
    {
        alias: 'status_time',
        unit_type: enums_1.MetricUnitTypeEnum.Countdown,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Status time',
        description: 'Time agent has been in current status.',
        agent: true,
        client_data: true,
        reset_pause: false,
    },
    {
        alias: 'status_busy',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Busy',
        description: 'Total number of agents with busy status.',
        client_data: true,
    },
    {
        alias: 'status_pause',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Pause',
        description: 'Total number of agents with pause status.',
        client_data: true,
    },
    {
        alias: 'status_idle',
        unit_type: enums_1.MetricUnitTypeEnum.Count,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        live: true,
        title: 'Idle',
        description: 'Total number of agents with idle status.',
        client_data: true,
    },
    {
        alias: 'first_login',
        unit_type: enums_1.MetricUnitTypeEnum.DateTime,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: null,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'First login time',
        description: 'First login time during selected period',
    },
    {
        alias: 'last_logout',
        unit_type: enums_1.MetricUnitTypeEnum.DateTime,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: null,
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Last logout time',
        description: 'Last logout time during selected period',
    },
    {
        alias: 'busy_voice_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Busy voice',
        description: 'Voice busy activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'busy_mail_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Busy e-mail',
        description: 'E-mail busy activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'busy_form_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Busy form',
        description: 'Form busy activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'login_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Login',
        description: 'Login activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'login_activity_only',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Login (only)',
        description: 'Login activity as highest status only.',
    },
    {
        alias: 'idle_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Idle',
        description: 'Idle activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'idle_activity_only',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Idle (only)',
        description: 'Idle activity as highest status only.',
    },
    {
        alias: 'handling_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Handling',
        description: 'Handling activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'handling_activity_only',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Handling (only)',
        description: 'Handling activity as highest status only.',
    },
    {
        alias: 'pause_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Pause',
        description: 'Pause activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'pause_activity_only',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Pause (only)',
        description: 'Pause activity as highest status only.',
    },
    {
        alias: 'busy_activity',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Busy',
        description: 'Busy activity (will be overwritten by higher statuses).',
    },
    {
        alias: 'busy_activity_only',
        unit_type: enums_1.MetricUnitTypeEnum.TimelineEvent,
        sources: [enums_1.MetricDataSourceEnum.UserActivityTimeline,],
        default: '"-"',
        channels: [],
        thread_channels: [],
        message_channels: [],
        directions: [],
        thread_directions: [],
        message_directions: [],
        title: 'Busy (only)',
        description: 'Busy activity as highest status only.',
    },
];
exports.GroupMetrics = [
    {
        alias: 'conversation_queue_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity, enums_1.MetricDataSourceEnum.Notification,],
        default: 0,
        title: 'Queue',
    },
    {
        alias: 'client_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Client',
    },
    {
        alias: 'direction',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Direction',
    },
    {
        alias: 'status',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Conversation status',
    },
    {
        alias: 'conversation_main_channel',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Main channel',
    },
    {
        alias: 'pause_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        title: 'Pause',
    },
    {
        alias: 'disposition_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Disposition',
    },
    {
        alias: 'sub_disposition_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Sub disposition',
    },
    {
        alias: 'thrd_disposition_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Third disposition',
    },
    {
        alias: 'conversation_user_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        title: 'User',
    },
    {
        alias: 'account_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        title: 'Account',
    },
    {
        alias: 'organization_id',
        unit_type: enums_1.MetricUnitTypeEnum.Number,
        sources: [enums_1.MetricDataSourceEnum.Conversation, enums_1.MetricDataSourceEnum.UserActivity,],
        default: 0,
        title: 'Organization',
    },
    {
        alias: 'thread_direction',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: '-',
        title: 'Thread direction',
    },
    {
        alias: 'thread_queue_id',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Thread queue',
    },
    {
        alias: 'thread_user_id',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Thread user',
    },
    {
        alias: 'message_channel',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: '-',
        title: 'Message channel',
    },
    {
        alias: 'message_direction',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: '-',
        title: 'Message direction',
    },
    {
        alias: 'message_queue_id',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Message queue',
    },
    {
        alias: 'message_user_id',
        unit_type: enums_1.MetricUnitTypeEnum.String,
        sources: [enums_1.MetricDataSourceEnum.Conversation,],
        default: 0,
        title: 'Message user',
    },
    {
        alias: 'hour',
        unit_type: enums_1.MetricUnitTypeEnum.DateTime,
        sources: [enums_1.MetricDataSourceEnum.Calendar,],
        default: null,
        title: 'Hour',
    },
    {
        alias: 'day',
        unit_type: enums_1.MetricUnitTypeEnum.Date,
        sources: [enums_1.MetricDataSourceEnum.Calendar,],
        default: null,
        title: 'Day',
    },
    {
        alias: 'week',
        unit_type: enums_1.MetricUnitTypeEnum.Week,
        sources: [enums_1.MetricDataSourceEnum.Calendar,],
        default: null,
        title: 'Week',
    },
    {
        alias: 'month',
        unit_type: enums_1.MetricUnitTypeEnum.Month,
        sources: [enums_1.MetricDataSourceEnum.Calendar,],
        default: null,
        title: 'Month',
    },
    {
        alias: 'hour_of_day',
        unit_type: enums_1.MetricUnitTypeEnum.HOUR_OF_DAY,
        sources: [enums_1.MetricDataSourceEnum.Calendar,],
        default: null,
        title: 'Hour of the day',
    },
    {
        alias: 'weekday',
        unit_type: enums_1.MetricUnitTypeEnum.WEEKDAY,
        sources: [enums_1.MetricDataSourceEnum.Calendar,],
        default: null,
        title: 'Weekday',
    },
    {
        alias: 'user_status',
        unit_type: enums_1.MetricUnitTypeEnum.Status,
        sources: [enums_1.MetricDataSourceEnum.UserActivity,],
        default: '"-"',
        live: true,
        title: 'User status',
        agent: true,
        client_data: true,
    },
];
